import * as React from "react";

;
export const ChevronUpSmll = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="m12 10.06-5.47 5.47-1.06-1.06L12 7.94l6.53 6.53-1.06 1.06L12 10.06Z" /></svg>;